/* global $ */

class StickyFooter {
  constructor(namespace) {
    this.$window = $(window);
    this.$container = $('.StickyFooter');
    this.$newsContainer = this.$container.find('.StickyFooterNews');
    this.$bottomSwitchElement = $('.Footer');

    this.state = 'top';
    this.namespace = namespace;

    if ($('.Section-contact').length) {
      this.$bottomSwitchElement = $('.Section-contact');
    }

    this.$container.attr('data-namespace', namespace);

    this.$window.on('resize', () => {
      this.onWindowResize();
    });
    this.onWindowResize();
  }

  pageChange(namespace) {
    this.namespace = namespace;
    this.$container.attr('data-namespace', namespace);
    this.onWindowResize();
  }

  onWindowResize() {
    if (this.namespace == 'home') {
      this.$newsContainer.css(
        'padding-left',
        `${parseInt($('.HeroBody').offset()['left'])}px`
      );
    }
  }

  update(scrollTop, windowHeight) {
    if (scrollTop > 0) {
      if (
        scrollTop >
        this.$bottomSwitchElement.offset()['top'] - windowHeight
      ) {
        this.state = 'bottom';
      } else {
        this.state = 'middle';
      }
    } else {
      this.state = 'top';
    }
    this.$container.attr('data-state', this.state);
  }
}

export default StickyFooter;
